import React, { useState } from 'react'
import styled from 'styled-components'
import { Devices } from '@raysync/common/theme'
import { useMedia } from '@raysync/common/hooks'
import TouchSwiper from './touch-swiper'
const TabContainer = styled.div`
  background: #ffffff;
  box-shadow: 0px 10px 30px 0px #e2e7ec;
`
// 定义一个TabHeader组件，用来显示tab头
const TabHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: #f5f7fb;
  > span {
    &:last-child {
      box-shadow: unset;
    }
  }
  @media ${Devices.phone} {
    flex-wrap: wrap;
  }
`

// 定义一个TabButton组件，用来显示每个tab的按钮
const TabButton = styled.h3`
  background-color: ${props => (props.active ? '#fff' : '#f5f7fb')};
  color: ${p => (p.active ? p.theme.color.secondary : p.theme.color.textDarkPlus)};
  border-top: 3px solid ${p => (p.active ? p.theme.color.secondary : 'transparent')};
  display: flex;
  justify-content: center;
  width: 25%;
  height: 80px;
  padding: 0 48px;
  text-align: center;
  display: flex;
  align-items: center;
  cursor: pointer;
  @media ${Devices.phone} {
    height: 0.8rem;
    width: 50%;
    padding: 0 0.4rem;
  }
`

// 定义一个TabContent组件，用来显示tab的内容
const TabContent = styled.div`
  display: flex;
  background-color: #ffffff;
  padding: 30px;
  h3 {
    width: 6.9rem;
    font-size: 0.3rem;
    font-weight: 500;
    color: ${p => p.theme.color.secondary};
    text-align: center;
    margin-bottom: 0.8rem;
    margin-top: 0.36rem;
    height: 0.85rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  @media ${Devices.phone} {
    padding: 0rem;
    flex-wrap: wrap;
  }
`

const MobileTabBox = styled.div`
  position: relative;
`

// 定义一个Image组件，用来显示内容的图片
const Image = styled.img`
  width: 670px;
  height: 440px;
  @media ${Devices.phone} {
    width: 100%;
    height: 4.4rem;
  }
`

// 定义一个Text组件，用来显示内容的文案
const Text = styled.div`
  width: 100%;
  padding-left: 36px;
  b {
    display: block;
    color: #252a3a;
    margin: 24px 0 8px;
    font-size: 20px;
    font-weight: 600;
  }
  p {
    font-size: 16px;
    color: #636772;
  }
  @media ${Devices.phone} {
    padding-left: 0;
    b {
      margin: 0.24rem 0 0.08rem;
      font-size: 0.24rem;
    }
    p {
      font-size: 0.2rem;
    }
  }
`

// 定义一个Tabs组件，用来封装tab的逻辑和渲染
const Tabs = ({ tabs }) => {
  // 定义一个state，用来记录当前激活的tab索引
  const [activeIndex, setActiveIndex] = useState(0)
  const isMobile = useMedia()
  // 定义一个函数，用来处理tab按钮的点击事件
  const handleTabClick = index => {
    // 设置当前激活的tab索引为点击的索引
    setActiveIndex(index)
  }

  if (isMobile) {
    return (
      <TouchSwiper barStyle={{ transform: 'translateY(5.8rem)' }}>
        {tabs.map((tab, index) => (
          <MobileTabBox>
            <TabContent>
              <Image src={tabs[index].image} alt={tabs[index].title} />
              <h3>{tab.title}</h3>
              <Text>{tabs[index].desc}</Text>
            </TabContent>
          </MobileTabBox>
        ))}
      </TouchSwiper>
    )
  }

  // 返回Tabs组件的JSX元素
  return (
    <TabContainer>
      {/* 渲染TabHeader组件 */}
      <TabHeader>
        {/* 遍历tabs数组，为每个tab渲染一个TabButton组件 */}
        {tabs.map((tab, index) => (
          <TabButton key={index} active={index === activeIndex} onClick={() => handleTabClick(index)}>
            {tab.title}
          </TabButton>
        ))}
      </TabHeader>
      {/* 渲染TabContent组件 */}
      <TabContent>
        {/* 根据当前激活的tab索引，渲染对应的内容 */}
        <Image src={tabs[activeIndex].image} alt={tabs[activeIndex].title} />
        <Text>{tabs[activeIndex].desc}</Text>
      </TabContent>
    </TabContainer>
  )
}

export default Tabs
